export default "__VITE_ASSET__JIdny5Bh__"